import styled from 'styled-components';
import { getFont } from '@finect/tabular-utils/getFont';
export var Label = styled.span.withConfig({
  displayName: "Label",
  componentId: "sc-1d97gm8-0"
})(["", " font-weight:700;color:", ";a{display:flex;align-items:center;}svg{margin-left:6px;}&:hover{a{opacity:1;}}"], getFont('0'), function (_ref) {
  var theme = _ref.theme;
  return theme.colors.primary;
});